import { render, staticRenderFns } from "./TagMaster.vue?vue&type=template&id=49f3446a&scoped=true&"
import script from "./TagMaster.vue?vue&type=script&lang=js&"
export * from "./TagMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f3446a",
  null
  
)

export default component.exports